<template>
    <q-dialog :value="dialogCategoriesMobile"
              @hide="closeDialogCategoryMobile"
              transition-show="slide-up"
              transition-hide="slide-down"
              :maximized="maximizedToggle">
        <q-card class="modal-filters">
            <div class="modal-header">
                <span class="modal-title">Категории</span>
                <div class="modal-close" @click="closeDialogCategoryMobile()">
                        <span aria-hidden="true">
                            <svg version="1.1" id="" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xli.nav-itemnk="http://www.w3.org/1999/xli.nav-itemnk" x="0px" y="0px"
                                 width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10"
                                 xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <div class="">
                    <div class="filter-menu">
                        <filter-item :filter="{
                                name: 'Категория',
                                open_by_default: true,
                                show: true,
                                show_by_default: true,
                                slug: 'category'
                            }"></filter-item>
                    </div>
                </div>
            </q-card-section>
            <q-card-actions class="q-pa-md">
                <q-btn @click="apply" color="primary" label="Применить" v-close-popup class="full-width"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex"
import FilterItem from "./../../Catalog/Filter/Item"

export default {
    name: "Categories",
    components: {
        FilterItem,
    },
    data() {
        return {
            maximizedToggle: true,
        }
    },
    computed: {
        ...mapState('catalog', [
            'dialogCategoriesMobile'
        ])
    },
    methods: {
        ...mapActions('catalog', [
            'applyFilters',
        ]),
        ...mapMutations('catalog', [
            'toggleDialogCategoriesMobile'
        ]),
        apply() {
            this.applyFilters()
            this.toggleDialogCategoriesMobile(false)
        },
        closeDialogCategoryMobile() {
            this.toggleDialogCategoriesMobile(false)
        },
    }
}
</script>

<style scoped>
.q-btn--rectangle {
    border-radius: 3px;
}
</style>
